import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { debounceTime, fromEvent, map } from 'rxjs';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.less',
})
export class SearchInputComponent {
  @Input() searchValue: string = '';
  @Input() delay: number = 300;
  @Output() searchValueChange = new EventEmitter();
  constructor(public elementRef: ElementRef) {
    const eventStream = fromEvent(elementRef.nativeElement, 'keyup')
      .pipe(
        map(() => this.searchValue),
        debounceTime(this.delay)
      )
      .subscribe((input) => {
        this.searchValueChange.emit(input.trim());
      });
  }

  ngOnInit(): void {}
}
